import { useQuery } from "@tanstack/react-query";
import {
  sanityClient,
  downloadsPageQuery,
  type DownloadCategoryWithItems,
} from "../sanity";

export function useDownloads() {
  return useQuery({
    queryKey: ["downloads"],
    queryFn: () =>
      sanityClient.fetch<DownloadCategoryWithItems[]>(downloadsPageQuery),
    staleTime: 1000 * 60 * 5,
  });
}
